// extracted by mini-css-extract-plugin
export default {"root":"RichTextarea_root__FVzit","container":"RichTextarea_container__sJEi1","textarea":"RichTextarea_textarea__xXtMI","textContainer":"RichTextarea_textContainer__5GD5n"};